import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { resolve } from 'core-js/fn/promise';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { FirebaseAuthService } from './firebase-auth.service';

@Injectable({
  providedIn: "root"
})
export class FirebaseProfilePageGuard implements CanActivate {
  hasUser: boolean;
  resolved: boolean;
  currentUserChanged: Subject<any> = new ReplaySubject<any>();

  constructor(
    private firebaseAuthService: FirebaseAuthService,
    private router: Router
  ) {
    this.firebaseAuthService.getCurrentUserChanged()
    .subscribe(result => {
      this.resolved = true;
      if (result !== null) {
        this.hasUser = true;;
      } 
      else {
        this.hasUser = false;
      }
      this.currentUserChanged.next(result);
    });
  }

  canActivate(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.resolved) {
        if (this.hasUser) {
          resolve(true);
        }
        else {
          this.router.navigate(['/login/auth/sign-in'])
          //resolve(this.router.parseUrl('/login/auth/sign-in'));
        }
      }
      else {
        var loggedInUser = this.firebaseAuthService.getLoggedInUser();
        if (loggedInUser !== null && loggedInUser !== undefined) {
          resolve(true);
          return;
        }
        
        this.currentUserChanged
        .subscribe(result => {
          this.resolved = true;
          if (result !== null) {
            this.hasUser = true;;
            resolve(true);
          } 
          else {
            this.router.navigate(['/login/auth/sign-in'])
            //resolve(this.router.parseUrl('/login/auth/sign-in'));
          }
        });
      }
    });
  }
  // canActivate(): boolean | UrlTree {
  //   // check if user is authenticated
  //   //if (this.firebaseAuthService.getLoggedInUser() != null) {
  //     if (this.hasUser) {
  //     return true;
  //   } else {
  //     // Navigate to the login page
  //     // this.router.navigate(['login/auth/sign-in'], {
  //     //   skipLocationChange: true,
  //     //   replaceUrl: false
  //     // });

  //     return this.router.parseUrl('/login/auth/sign-in');
  //     // this.router.navigateByUrl('/login/auth/sign-in', {
  //     //   skipLocationChange: true,
  //     //   replaceUrl: false
  //     // });
  //     //return false;
  //   }
  // }
}
